import { render, staticRenderFns } from "./VerticalManagement.vue?vue&type=template&id=d915f4b8"
import script from "./VerticalManagement.vue?vue&type=script&lang=js"
export * from "./VerticalManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports